<style>

input[type="password"], input[type="text"] {
  background-color: inherit;
  border: 0;
  border-radius: 0;
  color: white;
  margin: 0;
  width: 100%;
}

.container{
  display: grid;
  grid-template-columns: auto 32px 32px;
  border-bottom: 2px white solid;
  background-color: rgba(255,255,255,0.2);
  align-items: center;
}
.light{
  background-color: inherit;
}

.input{
  grid-column: 1;
}
.icon-valid{
  grid-column: 2;
}
.icon-view{
  grid-column: 3;
}

.icon-clear, .icon-check, .icon-visibility_off, .icon-remove_red_eye {
  font-size: 29px;
  color: white;
}
.icon-clear{
  color: red;
}
.icon-check{
  color: lightgreen;
}

</style>

<div class="container {theme == 'light' ? 'light' : ''}">
  <div class="input">
    {#if view}
    <input type="text" bind:value="{value}" on:keyup="{ () => dispatch('changed') }" autocomplete="off" autocapitalize="none">
    {:else}
    <input type="password" bind:value="{value}" on:keyup="{ () => dispatch('changed') }">
    {/if}
  </div>
  <div class="icon-valid">
    <i class="{ valid ? 'icon-check' : 'icon-clear' }"></i>
  </div>
  <div class="icon-view" on:click="{ () => view = !view }">
    <i class="{ view ? 'icon-visibility_off' : 'icon-remove_red_eye' }"></i>
  </div>
</div>


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let value = "";
export let valid = false;
export let theme = "dark";

let view = false;

</script>